export const fetchSystemTotals = async (selectedStormOption) => {
  try {
    const url = `https://2471d2z813.execute-api.us-east-2.amazonaws.com/system-results/${selectedStormOption}/og`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching system totals:', error);
    return { flooding: null, infiltration: null, outflow: null, runoff: null };
  }
};

export const fetchSystemResults = async (selectedStormOption, userData, devPlanID) => {
  try {
    if (selectedStormOption === undefined || userData === undefined || userData.id === undefined || devPlanID === undefined) {
      return { flooding: null, infiltration: null, outflow: null, runoff: null };
    }
    const url = `https://2471d2z813.execute-api.us-east-2.amazonaws.com/system-results/${selectedStormOption}/${userData.id}_${devPlanID}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching system results:', error);
    return { flooding: null, infiltration: null, outflow: null, runoff: null };
  }
};
